// extracted by mini-css-extract-plugin
export default {"text":"Vl8jj8","seat":"Lp9qUp","mobile":"oZyQ54","selected":"r63T2l","wholeTableReservation":"zlMIu2","seatTypeIcon":"qnCTR1"};